import type {ReactAction} from '@netx/core/bootstrap';
import {faImage} from '@netx/core-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canSelectCustomThumbnail} from '../enablers';
import {AssetCustomThumbnailActionLabel} from '../locales';
import {AssetCustomThumbnailEvent} from './constants';

export const assetCustomThumbnailActionSetIcon = faImage;

/**
 * Set asset custom thumbnail
 * @param params
 * @returns Action
 */
export const assetCustomThumbnailActionSet = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-custom-thumbnail-set',
	cb: () => dispatcher.trigger(AssetCustomThumbnailEvent.UPLOAD, asset),
	enableTest: () => canSelectCustomThumbnail(asset),
	icon: assetCustomThumbnailActionSetIcon,
	get label() {
		return AssetCustomThumbnailActionLabel.SELECT;
	},
	...params,
});

export default assetCustomThumbnailActionSet;
